import React, {Component} from 'react';
import {connect } from 'react-redux';
import { DragLayer } from 'react-dnd';
import {ItemTypes} from "./ItemsTypes";
import imgSrcAusparung from '../../../../image/aussparung.png';
import {SIZE_OF_CELL} from "../../../../constants/constants";

function getSizeOfCell (realWidth, widthOnScreen) {
    const numbeOfCells = realWidth / SIZE_OF_CELL,
        sizeOfCellOnSreen = widthOnScreen / numbeOfCells;
    return sizeOfCellOnSreen;
}

function snapToGrid(x, y, sizeOfCell) {
    const innerBouding = document.body.getElementsByClassName("inner-plan-step-2")[0].getBoundingClientRect();
    let snappedX, snappedY;
    if(((innerBouding.x - x) % (sizeOfCell/4))){
        snappedX = innerBouding.x - (Math.round((innerBouding.x - x) / (sizeOfCell/4)) * (sizeOfCell/4));
    }
    if(((innerBouding.y - y) % (sizeOfCell/4))){
        snappedY = innerBouding.y - (Math.round((innerBouding.y - y) / (sizeOfCell/4)) * (sizeOfCell/4));
    }
    return [snappedX, snappedY];
}

function getItemStyles(props) {
    let { initialOffset, currentOffset } = props;
    if (!initialOffset || !currentOffset) {
        return {
            display: 'none',
        }
    }
    if(props.currentOffset && props.currentOffset.y < 50){
        window.scrollBy(0, -10);
    }
    const element = document.body.getElementsByClassName("inner-plan-step-2")[0],
        currentLidHeight = props.buildValuesSides[+props.item.currentStep - 2].lids[props.item.index].height,
        currentLidWidth = props.buildValuesSides[+props.item.currentStep - 2].lids[props.item.index].length,
        clientWidth = element.clientWidth,
        realWidthOfInnerPlan = (props.item.currentStep === 2 || props.item.currentStep === 3) ?
            props.buildValues.length :
            props.buildValues.width,
        widthOfLidPreview = (clientWidth / realWidthOfInnerPlan) * currentLidWidth,
        heightOfLidPreview = (clientWidth / realWidthOfInnerPlan) * currentLidHeight,
        lidElement = props.item.isPlan ? document.querySelector(`.wrapper-plan-2-step-2 #id-${props.item.index}.lid-icon-hatching-step-2`) :
            document.querySelector(`.wrapper-lid-step-2 #id-${props.item.index}`),
        lidPositionX = lidElement.getBoundingClientRect().x,
        lidPositionY = lidElement.getBoundingClientRect().y;

    let { x, y } = currentOffset;
    [x, y] = snapToGrid(x, y, getSizeOfCell(realWidthOfInnerPlan, clientWidth));
    x -= initialOffset.x;
    y -= initialOffset.y;

    const transform = `translate(${x}px, ${y}px)`;

    return {
        height : heightOfLidPreview + "px",
        width : widthOfLidPreview + "px",
        position :"fixed",
        border : "1px solid black",
        left: lidPositionX + "px",
        top : lidPositionY + "px",
        pointerEvents: "none",
        background : "repeating-linear-gradient( -45deg,rgba(255,255,255,0.5),rgba(255,255,255,0.5) 30px,gray 1px,gray 31px)",
        transform ,
        WebkitTransform: transform,
    }
}
function getSleeveStyle(props){
    const { initialOffset, currentOffset } = props;
    if (!initialOffset || !currentOffset) {
        return {
            display: 'none',
        }
    }
    const element = document.body.querySelector(".options-area-step-2 .sleeves-item-icon"),
        currentSleeveHeight = element.clientHeight,
        sleeveElement = props.item.isSleeveOnPlan ?
            document.body.querySelector(`.wrapper-plan-2-step-2 span[id='${props.item.index}'].sleeves-item-icon`) :
            document.body.querySelector(`.options-area-step-2 span[id='${props.item.background}'].sleeves-item-icon`);
       const  sleevePositionX = sleeveElement.getBoundingClientRect().x,
        sleevePositionY = sleeveElement.getBoundingClientRect().y;
    let { x, y } = currentOffset;
    x -= initialOffset.x;
    y -= initialOffset.y;
    const increaseIndex = window.innerWidth <= 420 ? currentSleeveHeight / 100 * 10 : 0;
    const sleveePositionKoef = window.innerWidth <= 420 ? 20 : 0;
    const transform = `translate(${x}px, ${y}px)`;
    return {
        position :"fixed",
        height : currentSleeveHeight + increaseIndex + "px",
        width  : currentSleeveHeight + increaseIndex + "px",
        left: sleevePositionX - sleveePositionKoef + "px",
        top : sleevePositionY  + "px",
        background: props.item.background,
        transform ,
        WebkitTransform: transform,
    }
}
class LidCustomPreview extends Component{

    static propTypes = {

    };

    render(){
        const { item, itemType, isDragging} = this.props;
        // if(itemType === ItemTypes.CELL){
        //     console.log("props preview", this.props);
        //     return   <span className="sleeves-item-icon"/>
        // }
        if(!isDragging || item.widthoutDragging) {
            return null
        }
        if(itemType === ItemTypes.CELL){
            const styleForSleeve = getSleeveStyle(this.props);
            return (
                <span className="sleeves-item-icon" style = {{...styleForSleeve, pointerEvents : "none"}}/>
            );
        }

        const styles = getItemStyles(this.props);

        if(!item.sagex){
            return (
                <img src={imgSrcAusparung} style={styles} alt={"ausparung_sagex"}/>
            );
        }
        return (
            <div id ="lidCustomPreview" style = {styles}/>
        )
    }
}

const monitor = (monitor) => {
    let initialOffset;
    const item = monitor.getItem(),
        itemType = monitor.getItemType();
    if(item && itemType === ItemTypes.LID && !item.isPlan) {
        initialOffset = document.querySelectorAll(".wrapper-lid-step-2 .lid-icon-hatching-step-2")[item.index].getBoundingClientRect();
    }else{
        initialOffset = monitor.getInitialSourceClientOffset();
    }
    return {
        item: item,
        itemType: itemType,
        initialOffset: initialOffset,
        currentOffset: monitor.getSourceClientOffset(),
        isDragging: monitor.isDragging(),
    }
};

const mapStateToProps = (state) => {
    return {
        buildValues : state.buildValues,
        buildValuesSides : state.buildValuesSides
    }
};

const mapStateToDispatch = {

};

export default connect(mapStateToProps, mapStateToDispatch)(DragLayer(monitor)(LidCustomPreview))


// WEBPACK FOOTER //
// ./src/containers/steps/BuildSteps/BuildsComponent/LidCustomPreview.js